import { Schema } from '@core/data/dto/schema';
import { EmployeeProviderData } from './employee-provider-data';
import moment from 'moment';
import { FORMAT } from '@core/utils/formats';
import { Workplace } from '../shared/workplace/workplace';
import { Paystub } from '../shared/paystub/paystub';
import { EmployeeIssue } from './employee-issue';
import { EmployeeResidence } from './employee-residence';
import { EmployeeWage } from './employee-wage';
import { PaySchedule } from '../pay-schedule/pay-schedule';
import { LeavePolicy } from '../leave/leave-policy';

export const EmployeeSchema = {
    id: Schema.String,
    avatar_url: Schema.String,
    connection: Schema.Auto,
    email: Schema.String,
    first_name: Schema.String,
    middle_name: Schema.String,
    last_name: Schema.String,
    name: Schema.String,
    link_id: Schema.String,
    link_status: Schema.Auto,
    ignore_link: Schema.Boolean,
    onboard_status: Schema.Auto,
    phone: Schema.String,
    payment_method_preference: Schema.Auto,
    pay_schedule: PaySchedule,
    provider_id: Schema.String,
    provider: Schema.Auto,
    provider_data: EmployeeProviderData,
    provider_name: Schema.String,
    provider_type: Schema.String,
    actions: Schema.Auto,
    start_date: Schema.Moment,
    termination_date: Schema.Moment,
    inactive_date: Schema.Moment,
    ssn_last_four: Schema.String,
    warnings: [EmployeeIssue],
    workplaces: [Workplace],
    w2_electronic_consent_provided: Schema.Boolean,
    date_of_birth: Schema.Moment,
    residence: EmployeeResidence,
    paystubs: [Paystub],
    wages: [EmployeeWage],
    policies: [LeavePolicy],
    current_wage: {
        map: 'currentWage',
        mapImport: (value: any) => {

            if (!value) {
                return null;
            } else {
                return {
                    id: value?.id,
                    wageType: value?.wage_type,
                    wageTypeLabel: value?.wage_type ? 'Employees.Details.WagetType.' + value?.wage_type : '',
                    effective: moment(value?.effective, FORMAT.DATE_SHORT),
                    amount: value?.salary?.amount || 0
                }
            }
        }
    },
    next_wage: {
        map: 'nextWage',
        mapImport: (value: any) => {

            if (!value) {
                return null;
            } else {
                return {
                    wageType: value?.wage_type,
                    wageTypeLabel: value?.wage_type ? 'Employees.Details.WagetType.' + value?.wage_type : '',
                    effective: moment(value?.effective, FORMAT.DATE_SHORT),
                    amount: value?.salary?.amount
                }
            }
            
        }
    }
};
